import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";
import MidiNumbers from "./MidiNumbers";
import {
  highlightVoiceKey,
  setCurrentSongIndex,
  setGhostTonesMT,
  setSustainedNotes,
  setSustainPedal,
  // setMusicTheoryMidiNums,
  setTonesMT,
  setVoice,
} from "./store/actions";
import _ from "lodash";

class Key extends React.Component {
  globalMidiAccess = null;
  notesMidiNum = this.props.notesMidiNum;
  static propTypes = {
    midiNumber: PropTypes.number.isRequired,
    naturalKeyWidth: PropTypes.number.isRequired, // Width as a ratio between 0 and 1
    gliss: PropTypes.bool.isRequired,
    useTouchEvents: PropTypes.bool.isRequired,
    accidental: PropTypes.bool.isRequired,
    active: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    onPlayNoteInput: PropTypes.func.isRequired,
    onStopNoteInput: PropTypes.func.isRequired,
    accidentalWidthRatio: PropTypes.number.isRequired,
    pitchPositions: PropTypes.object.isRequired,
    children: PropTypes.node,
    sustainedNotes: PropTypes.instanceOf(Set),
    sustainPedalNTToggle: PropTypes.bool,
  };

  static defaultProps = {
    accidentalWidthRatio: 0.65,
    sustainedNotes: new Set(),
    pitchPositions: {
      C: 0,
      "D♭": 0.55,
      D: 1,
      "E♭": 1.8,
      E: 2,
      F: 3,
      "G♭": 3.5,
      G: 4,
      "A♭": 4.7,
      A: 5,
      "B♭": 5.85,
      B: 6,
    },
  };

  onPlayNoteInput = (e) => {
    let element = document.querySelector(
      `[data-midi="${String(this.props.midiNumber)}"] .react-piano-music-dots`
    );
    let classes = element.className;
    let songIndex;
    if (
      classes?.includes("grey") &&
      !classes?.includes("blue") &&
      !classes?.includes("red") &&
      this.props.applyGhost
    ) {
      const { currentSong } = this.props;
      // set tonesMT to ghost formula
      this.props.setTonesMT({ ...this.props.ghostTonesMT });
      if (
        this.props.currentSongIndex + 1 >
        this.props.songsArray[currentSong][this.props.currentSectionName]
          .length -
          1
      ) {
        this.props.setCurrentSongIndex(0);
        songIndex = 0;
      } else {
        songIndex = this.props.currentSongIndex + 1;
        this.props.setCurrentSongIndex(this.props.currentSongIndex + 1);
      }

      if (
        this.props.songsArray[currentSong][this.props.currentSectionName][
          songIndex + 1
        ]
      ) {
        this.props.setGhostTonesMT(
          this.props.songsArray[currentSong][this.props.currentSectionName][
            songIndex + 1
          ]
        );
      } else {
        this.props.setGhostTonesMT(
          this.props.songsArray[currentSong][this.props.currentSectionName][0]
        );
      }
    }

    this.props.onPlayNoteInput(this.props.midiNumber);
  };

  playExternalMidi = (externalMidiNumber) => {
    if (this.props.midiNumber !== externalMidiNumber) {
      return;
    }
    this.onPlayNoteInput();
  };

  onStopNoteInput = () => {
    this.props.onStopNoteInput(this.props.midiNumber);
  };

  stopExternalMidi = (externalMidiNumber) => {
    if (this.props.midiNumber !== externalMidiNumber) {
      return;
    }
    this.onStopNoteInput();
  };

  playFromKeyboard = (keyboardNumber) => {
    if (this.props.midiNumber !== keyboardNumber) {
      return;
    }
    this.onPlayNoteInput();
  };

  stopFromKeyboard = (keyboardNumber) => {
    if (this.props.midiNumber !== keyboardNumber) {
      return;
    }
    this.onStopNoteInput();
  };

  // Key position is represented by the number of natural key widths from the left
  getAbsoluteKeyPosition(midiNumber) {
    const OCTAVE_WIDTH = 7;
    const { octave, pitchName } = MidiNumbers.getAttributes(midiNumber);
    const pitchPosition = this.props.pitchPositions[pitchName];
    const octavePosition = OCTAVE_WIDTH * octave;
    return pitchPosition + octavePosition;
  }

  getRelativeKeyPosition(midiNumber) {
    return (
      this.getAbsoluteKeyPosition(midiNumber) -
      this.getAbsoluteKeyPosition(this.props.config.noteRange.first)
    );
  }

  render() {
    const {
      naturalKeyWidth,
      // accidentalWidthRatio,
      midiNumber,
      gliss,
      useTouchEvents,
      accidental,
      active,
      disabled,
      children,
      notesMidiNum,
      highlightkeyNumberForVoice,
      sustainPedal,
      sustainedNotes,
      sustainPedalNTToggle,
      // highlightVoiceKey,
    } = this.props;

    let isActive;
    if(sustainPedalNTToggle){
      isActive = active || (sustainPedal && sustainedNotes.has(midiNumber));
    }
    else{
      isActive = active;
    }
      
    const getClassNames = (props, notesMidiNum) => {
      const {
        midiNumber,
        highlightkeyNumberForVoice,
        tonesMT,
        enableMidiFlag,
        showWrongMidiInput,
        voiceDetect,
        showWrongMicInput,
        accidental,
        sustainPedal,
        sustainedNotes,
      } = this.props;

    if (
      (highlightkeyNumberForVoice[0] == midiNumber &&
        highlightkeyNumberForVoice[0] !== 0) ||
      isActive
    ) {
      if (
        tonesMT.modesOfScalesValues?.name &&
        !this.props.musicTheoryMidiNums.includes(midiNumber) &&
        ((enableMidiFlag && showWrongMidiInput) ||
          (voiceDetect && showWrongMicInput))
      ) {
        return isActive
          ? "ReactPiano__Key--lowestNote-midi"
          : accidental
          ? "ReactPiano__Key--lowestNote-accidental"
          : "ReactPiano__Key--lowestNote";
      }
      if (midiNumber < notesMidiNum.bridgeVoiceNote[1]) {
        return isActive
          ? "ReactPiano__Key--bridgeNote-midi"
          : accidental
          ? "ReactPiano__Key--bridgeNote-accidental"
          : "ReactPiano__Key--bridgeNote";
      }

      if (midiNumber >= notesMidiNum.bridgeVoiceNote[1]) {
        return isActive
          ? "ReactPiano__Key--highestNote-midi"
          : accidental
          ? "ReactPiano__Key--highestNote-accidental"
          : "ReactPiano__Key--highestNote";
      }

      return isActive
        ? "ReactPiano__Key--voiceHighlight-midi"
        : accidental
        ? "ReactPiano__Key--voiceHighlight-accidental"
        : "ReactPiano__Key--voiceHighlight";
    }
    return "";
  }
    const conditionalClassName = getClassNames(
      { midiNumber, highlightkeyNumberForVoice },
      notesMidiNum
    );
    const bridgeClass =
      midiNumber == notesMidiNum.bridgeVoiceNote[1] && this.props.showRange
        ? "border-left"
        : midiNumber == notesMidiNum.bridgeVoiceNote[0] && this.props.showRange
        ? "border-right"
        : "";
    // Need to conditionally include/exclude handlers based on useTouchEvents,
    // because otherwise mobile taps double fire events.
    return (
      <div
        className={classNames("ReactPiano__Key", {
          "ReactPiano__Key--accidental": accidental,
          "ReactPiano__Key--natural": !accidental,
          "ReactPiano__Key--disabled": disabled,
          [conditionalClassName]: conditionalClassName,
          "ReactPiano__Key--active": isActive,
          [bridgeClass]: bridgeClass,
        })}
        data-midi={this.props.midiNumber}
        style={{
          left: ratioToPercentage(
            this.getRelativeKeyPosition(midiNumber) * naturalKeyWidth
          ),
          // width: ratioToPercentage(
          //   accidental
          //     ? accidentalWidthRatio * naturalKeyWidth
          //     : naturalKeyWidth
          // ),
        }}
        onMouseDown={useTouchEvents ? null : this.onPlayNoteInput}
        onMouseUp={useTouchEvents ? null : this.onStopNoteInput}
        onMouseEnter={gliss ? this.onPlayNoteInput : null}
        onMouseLeave={this.onStopNoteInput}
        onTouchStart={useTouchEvents ? this.onPlayNoteInput : null}
        onTouchCancel={useTouchEvents ? this.onStopNoteInput : null}
        onTouchEnd={useTouchEvents ? this.onStopNoteInput : null}
      >
        <div
          className={classNames("react-piano-music-dots", {
            sharp: accidental,
            main: !accidental,
          })}
        >
          <span className="number"></span>
        </div>
        <div className="ReactPiano__NoteLabelContainer hide-labels">
          {children}
        </div>
      </div>
    );
  }
}

function ratioToPercentage(ratio) {
  return `${ratio * 100}%`;
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    highlightkeyNumberForVoice: state.highlightkeyNumberForVoice,
    notesMidiNum: state.notesMidiNum,
    ghostTonesMT: state.ghostTonesMT,
    tonesMT: state.tonesMT,
    currentSong: state.currentSong,
    songsArray: state.songsArray,
    applyGhost: state.applyGhost,
    currentSongIndex: state.currentSongIndex,
    currentSectionName: state.currentSectionName,
    musicTheoryMidiNums: state.musicTheoryMidiNums,
    showWrongMicInput: state.showWrongMicInput,
    showWrongMidiInput: state.showWrongMidiInput,
    voiceDetect: state.voiceDetect,
    enableMidiFlag: state.enableMidiFlag,
    showRange: state.showRange,
    sustainPedal: state.sustainPedal,
    sustainedNotes: state.sustainedNotes,
    sustainPedalNTToggle: state.sustainPedalNTToggle,
  };
};

const mapDispatchToProps = {
  setVoice,
  setGhostTonesMT,
  setTonesMT,
  setCurrentSongIndex,
  highlightVoiceKey,
  setSustainPedal,
  setSustainedNotes,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Key);
